module.exports = __webpack_public_path__ + "static/fox-bfd26307494457c5fde3d2a2317b9b70.jpg";